/** @jsx h */

import { labels } from '../config';
import Checkbox from './Checkbox';

const FilterFieldset = ({ id, facet, triggerAjaxSubmit, pluginNamespace }) => {
  function handleInputChange() {
    triggerAjaxSubmit();
  }

  return (
    <div
      className="search__filter-inner"
      id={`fieldset-panel-${facet.type}-${id}`}
      aria-labelledby={`fieldset-${facet.type}-${id}`}
    >
      <header className="search__filter-header">
        <p className="is-text">{labels.faceting.narrowSearch}:</p>
      </header>

      <ul className="search__filter-list">
        {facet.options.length
          ? facet.options.map(option => (
              <Checkbox
                option={option}
                filterName={facet.name}
                handleChange={handleInputChange}
                pluginNamespace={pluginNamespace}
                key={option.value}
              />
            ))
          : ''}
      </ul>
    </div>
  );
};

export default FilterFieldset;
